// 原生title由浏览器窗口绘制，无法可靠主动销毁；统一接管为唯一、可销毁的全文提示。
let dismissCurrent:()=>void=()=>undefined
let disposeCurrent:()=>void=()=>undefined
export function dismissNavigationHoverHints(){
  dismissCurrent()
  // 兼容已有组件提示；不操作业务Modal、Drawer或点击型Popover。
  Array.from(document.querySelectorAll(':hover')).reverse().forEach(el=>{
    el.dispatchEvent(new MouseEvent('mouseout',{bubbles:true,relatedTarget:document.body}))
    el.dispatchEvent(new MouseEvent('mouseleave',{relatedTarget:document.body}))
  })
}
export function restoreNavigationHoverHints(){dismissCurrent()}
export function installNavigationHoverHints(app:{unmount:()=>void}){
  disposeCurrent()
  const titles=new Map<HTMLElement,{title:string,content:string|null}>()
  let ownerContent:string|null=null
  let owner:HTMLElement|null=null,tip:HTMLDivElement|null=null,timer:ReturnType<typeof setTimeout>|undefined,blocked=false
  const hide=()=>{if(timer)clearTimeout(timer);timer=undefined;tip?.remove();tip=null}
  const restore=()=>{
    titles.forEach((saved,el)=>{if(el.isConnected && !el.hasAttribute('title') && el.textContent===saved.content)el.setAttribute('title',saved.title)})
    titles.clear()
  }
  const dismiss=()=>{hide();observer.disconnect();owner=null;blocked=true}
  const capture=(target:Element)=>{
    let current:Element|null=target
    while(current){
      if(current instanceof HTMLElement && current.hasAttribute('title')){
        titles.set(current,{title:current.getAttribute('title') || '',content:current.textContent})
        current.removeAttribute('title')
      }
      current=current.parentElement
    }
  }
  const observer=new MutationObserver(()=>{
    if(!owner?.isConnected || owner.textContent!==ownerContent){dismiss();return}
    capture(owner)
  })
  const begin=(target:EventTarget|null)=>{
    if(!(target instanceof HTMLElement) || tip?.contains(target))return
    if(owner?.contains(target))return
    hide();observer.disconnect();owner=null;restore()
    const candidate=target.closest<HTMLElement>('[title]')
    if(!candidate)return
    const text=candidate.getAttribute('title') || ''
    capture(target)
    if(blocked || !text.trim())return
    owner=candidate
    ownerContent=candidate.textContent
    observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['title']})
    timer=setTimeout(()=>{
      if(blocked || !owner?.isConnected || owner.closest('.ant-tooltip-open,.ant-popover-open'))return
      tip=document.createElement('div');tip.className='admin-managed-title-hint';tip.setAttribute('role','tooltip');tip.textContent=titles.get(owner)?.title || text
      tip.style.cssText='position:fixed;z-index:1100;pointer-events:auto;max-width:min(520px,calc(100vw - 24px));max-height:calc(100vh - 24px);overflow:auto;overflow-wrap:anywhere;white-space:pre-wrap;padding:8px 10px;border:1px solid #d9dfe8;border-radius:4px;background:#fff;color:#263445;box-shadow:0 3px 12px #0003;font:12px/1.6 sans-serif'
      document.body.appendChild(tip)
      const anchor=owner.getBoundingClientRect(),rect=tip.getBoundingClientRect(),width=document.documentElement.clientWidth,height=document.documentElement.clientHeight
      tip.style.left=Math.max(8,Math.min(anchor.left,width-rect.width-8))+'px'
      tip.style.top=Math.max(8,anchor.bottom+rect.height<=height-8?anchor.bottom:anchor.top-rect.height)+'px'
    },400)
  }
  const over=(event:Event)=>begin(event.target)
  const move=(event:Event)=>{if(blocked){blocked=false;begin(event.target)}}
  const out=(event:Event)=>{
    const next=(event as PointerEvent).relatedTarget
    if(owner && (!(next instanceof Node) || !owner.contains(next) && !tip?.contains(next))){hide();observer.disconnect();owner=null;restore()}
  }
  const key=(event:KeyboardEvent)=>{if(!['Shift','Control','Alt','Meta'].includes(event.key))dismiss()}
  const interaction=(event:Event)=>{if(tip && event.target instanceof Node && tip.contains(event.target))return;dismiss()}
  const blur=()=>{dismiss();restore()}
  document.addEventListener('pointerover',over,true);document.addEventListener('pointermove',move,true);document.addEventListener('pointerout',out,true)
  document.addEventListener('pointerdown',interaction,true);document.addEventListener('keydown',key,true);document.addEventListener('scroll',interaction,true)
  window.addEventListener('blur',blur);window.addEventListener('resize',dismiss)
  dismissCurrent=dismiss
  const dispose=()=>{
    blur();document.removeEventListener('pointerover',over,true);document.removeEventListener('pointermove',move,true);document.removeEventListener('pointerout',out,true)
    document.removeEventListener('pointerdown',interaction,true);document.removeEventListener('keydown',key,true);document.removeEventListener('scroll',interaction,true)
    window.removeEventListener('blur',blur);window.removeEventListener('resize',dismiss)
    if(dismissCurrent===dismiss)dismissCurrent=()=>undefined
  }
  disposeCurrent=dispose
  const unmount=app.unmount.bind(app);app.unmount=()=>{dispose();unmount()}
  return dispose
}
